import React from 'react';

import TextFilter from 'components/search_sidebar/sidebar_search';

import type { Filters } from './types';
import { FormLabel } from 'react-bootstrap-5';

type Slice = Pick<Filters, 'query'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function QueryFilter({ query, onChange }: Props) {
  return (
    <div>
      <FormLabel htmlFor="query-filter">Search</FormLabel>
      <TextFilter
        className="me-2"
        inputProps={{ id: 'query-filter' }}
        placeholder="Search Activities"
        value={query}
        onChange={event => onChange({ query: event.target.value })}
      />
    </div>
  );
}
